export async function loadExternalPauseInteraction(engine, refresh = true) {
    await engine.addInteractor("externalPause", async (container) => {
        const { Pauser } = await import("./Pauser.js");
        return new Pauser(container);
    }, refresh);
}
